module.exports = __webpack_public_path__ + "static/media/tapx-logo-white.4281a5c5.png";